module.exports = "/fonts/TT-Norms-Pro-Normal.ttf";